module.exports = __webpack_public_path__ + "img/icon_full_en.3277687d.png";